<template>
    <!--通知公告-->
    <section class="otice">
        <div class="oticeFrame nrk">
            <img src="./img/oticeIcon.jpg" class="oticeIcon">
            <div class="oticeNews" id="marquee2">
                <vue-seamless-scroll
                class="warp"
                :data="Notice.data"
                :class-option="defaultOption"
                >  
                <ul>
                    <li v-for="item in Notice.data" :key="item.id">
                        <a>· {{item.title}} <span class="risj">[{{item.push_time}}]</span></a>
                    </li>
                </ul>
                </vue-seamless-scroll>
            </div>
        </div>
    </section>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
    name:'NNotice',
    props:['Notice'],
    data() {
        return {
            defaultOption: {
                step: 0.4, // 数值越大速度滚动越快
                limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: true, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            },
        }
    },
    components:{
        vueSeamlessScroll
    }
}
</script>

<style scoped>
  .warp {
    height: 270px;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    }
    .otice{
        width: 100%;
        overflow: hidden;
        box-shadow: 0px 3px 3px #d9d9d9;
    }
    .oticeFrame{
        height: 70px;
        margin: 0 auto;
    }
    .oticeFrame .oticeIcon{
        float: left;
    }
    .oticeNews{
        width: 85%;
        float: left;
        height: 70px;
        overflow: hidden;
    }
    .oticeNews li{
        float: left;
        line-height: 70px;
        width: 100%;
        padding: 0 20px;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }
    .oticeNews li a{
        display: block;
    }
    .oticeNews li a:hover{
        color: #3dabed;;
    }
    .risj{
        color: #999;
    }
    @media (max-width: 768px){
		.oticeFrame{
			height: 50px;
		}
        .oticeFrame img{
            width: 30%;
        }
        .oticeNews li {
            width: 50%;
            line-height: 43px;
        }
        .oticeNews{
            height: 50px;
            width: 70%;
        }
	}
</style>
